import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import Icon from '../../common/Icons';
import { DOCTOR_COPY } from '../doctorCopy';
import { useDoctorWorkspace } from '../doctorWorkspaceContext';

/**
 * Écran « cadrage » pour modules clinique encore en développement.
 *
 * @param {{ placeholderKey: keyof typeof DOCTOR_COPY.MODULE_PLACEHOLDER }} props
 */
export default function DoctorModulePlaceholderPage({ placeholderKey }) {
  const navigate = useNavigate();
  const { portalPaths } = useDoctorWorkspace();
  const meta = DOCTOR_COPY.MODULE_PLACEHOLDER?.[placeholderKey];

  if (!meta) {
    return null;
  }

  return (
    <Container fluid className="doctor-dashboard recv-dash-pro--main px-0">
      <Row className="justify-content-center">
        <Col xl={9}>
          <Card className="shadow-sm border-0">
            <Card.Body className="p-4 p-md-5">
              <div
                className="mb-3 d-inline-flex align-items-center justify-content-center rounded-circle bg-light"
                style={{ width: 72, height: 72 }}
              >
                <Icon name={meta.icon || 'infoCircle'} size={34} className="text-primary" />
              </div>
              <h3 className="mb-3">{meta.title}</h3>
              <p className="text-muted lh-lg mb-4">{meta.description}</p>
              <Button variant="primary" onClick={() => navigate(portalPaths.DASHBOARD)}>
                {DOCTOR_COPY.PLACEHOLDER_BACK}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
